(function () {
  'use strict';

  angular.module('web2print.shared')
        .directive('savedCampaignModal', savedCampaignModal);

  /* @ngInject */
  function savedCampaignModal () {
    return {
      restrict: 'E',
      templateUrl: 'components/landing/saved-campaign-modal/saved-campaign-modal.html',
      scope: {
        //   data: '='
      },
      controller: SavedCampaignModalController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  SavedCampaignModalController.$inject = ['Common', 'progressTrackerFactory', '$location', '$translate', '$scope', '$state'];

  /* @ngInject */
  function SavedCampaignModalController (Common, progressTrackerFactory, $location, $translate, $scope, $state) {
    const vm = this;

    vm.productName = '';
    vm.show = false;
    vm.cancel = cancel;
    vm.finish = finish;

    function cancel () {
      const currentServiceCard = Common.get('serviceType', '');

      Common.resetOrderData();
      Common.set('serviceType', currentServiceCard);

      vm.show = false;
      $state.go('main.recipients');
    }

    function finish () {
      const path = progressTrackerFactory.getContinuePath();

      $location.path(path);
      vm.show = false;
      return;
    }

    function setProductName () {
      const serviceType = Common.get('serviceType', 'information');
      vm.productName = $translate.instant(Common.getServiceNameTranslationKey(serviceType));
    }

    function activate () {
      if (progressTrackerFactory.hasSavedCampaign()) {
        setProductName();
        vm.show = true;
      }
    }

    if (!['main.payment-redirect', 'main.receipt'].includes($state.current.name)) {
      activate();
    }

    $scope.$on('changeLanguage', function (events, language) {
      setProductName();
    });
  }

})();
